import { Box, Typography } from "@mui/material";
import FieldNotesDatePicker from "../datePicker/fieldNotesDatePicker.component";

const FieldNotesFilterDates = ({
  isMobile,
  startDate,
  endDate,
  onStartChange,
  onEndChange,
}) => {
  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      gap={2}
      alignItems={"center"}
      height={"100%"}
    >
      <Box display="flex" gap={1} alignItems={"center"} width={"100%"}>
        <Typography fontSize="12px" color="#616161">
          Da
        </Typography>
        <FieldNotesDatePicker
          selectedDate={startDate}
          handleDateSelect={(date) => {
            onStartChange(date);

            if (endDate && date && endDate < date) onEndChange(null);
          }}
          max
          Date={endDate || undefined}
        />
      </Box>
      <Box display="flex" gap={1} alignItems={"center"} width={"100%"}>
        <Typography fontSize="12px" color="#616161">
          A
        </Typography>
        <FieldNotesDatePicker
          selectedDate={endDate}
          handleDateSelect={onEndChange}
          minDate={startDate || undefined}
        />
      </Box>
    </Box>
  );
};

export default FieldNotesFilterDates;
